var MobileLoadingStates = /** @class */ (function () {
    function MobileLoadingStates() {
        this.talent = false;
        this.files = false;
        this.threads = false;
        this.thread = false;
        this.forms = false;
        this.timeline = false;
    }
    return MobileLoadingStates;
}());
export { MobileLoadingStates };
export var DraftingTableState;
(function (DraftingTableState) {
    DraftingTableState["INITIAL"] = "initial";
    DraftingTableState["UP_TO_DATE"] = "upToDate";
    DraftingTableState["CHANGED"] = "changed";
    DraftingTableState["ATTEMPTING_TO_SAVE"] = "attemptingToSave";
    DraftingTableState["VALIDATION_ERRORS"] = "validationErrors";
    DraftingTableState["API_ERRORS"] = "apiErrors";
})(DraftingTableState || (DraftingTableState = {}));
